import { IndexData } from "components/Chart/utils";

export const formatDate = (date?: string | Date): string => {
  if (!date) {
    return "";
  }

  const d = typeof date === "string" ? new Date(date) : date;

  return d.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export const formatShortDate = (date?: string): string => {
  if (!date) {
    return "";
  }
  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    year: "2-digit",
  });
};

export const getDateFromTimeframe = (timeframe: string): Date => {
  const timeFrameMap: Record<string, number> = {
    "1Y": 1,
    "3Y": 3,
    "5Y": 5,
    "10Y": 10,
    ALL: 99,
  };

  const today = new Date();
  const date = new Date(
    today.setFullYear(today.getFullYear() - timeFrameMap[timeframe]),
  );
  return date;
};

export const filterIndexDataByDate = (data: IndexData[], startDate: Date) =>
  data.filter(
    ({ date }: { date: string }) =>
      startDate.getTime() < new Date(date).getTime(),
  );
